<template>
    <div id="telematicsReadingList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Asset List For Warranty </div>
                    <!-- <router-link v-bind:to="'/warranty/list'" class="btn btn-secondary pull-right">
                        <i class="fp-back"></i>  Back
                    </router-link> -->
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackWarrantyList" >
                        <i class="fp-back"> </i>    Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-warranty-list">
                        <section class="internal-container border-top-table-fl">
                            <div class="form-row asset-top-section">
                                <div class="col-sm-6">
                                    <label class="control-label" for="Vehicle">Warranty:</label>
                                    <span class="label">{{formatString(warCode)}}</span>
                                </div>
                                <div class="col-sm-6">
                                    <label class="control-label" for="Vehicle">Starting Point Value:</label>
                                    <span class="label">{{formatString(starting_point_value)}}</span>
                                </div>
                            </div>
                        </section>
                        <section class="data-table bg-white mt-4">
                                <data-table-filter-config :moduleName="'assetWarrantyList'" ref="filterAssetWarranty" @cancelSelection="cancelAll"></data-table-filter-config>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'assetWarrantyList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="assetWarrantyList"
                                    mode="remote"
                                    title="Asset Warranty"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'bottom',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">
                                     <div slot="selected-row-actions">
                                        <button v-if="canAddWarranty == true && currentStatus == 'No'" id="deleteCustomerBtn" v-on:click.prevent="addAssetWarranty" class="btn btn-primary">Add Warranty</button>
                                        <button v-if="canRemoveWarranty == true && currentStatus == 'Yes'" id="deleteCustomerBtn" v-on:click.prevent="removeAssetWarranty" class="btn btn-danger">Remove Warranty</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>

                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "readingList",
        metaInfo() {
            return {title: "Asset List For Warranty | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],

        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: true,
            selectedFile:"",
            deviceType:"",
            error:"",
            notfound:false,
            notFoundArr:[],
            unitNum:"",
            reading:"",
            section:"",
            id:0,
            columns: [
                {
                    label: '# Unit',
                    field: 'unit_no',
                    filterable: true,
                    hidden:false,
                    // type: "number",
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Manufacturer',
                    field: 'manufacturer',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Manufacturer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Model',
                    field: 'model',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Model", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                {
                    label: 'Year',
                    field: 'year',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:true,
                },
                {
                    label: 'Group',
                    field: 'group',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Group", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Purchased',
                    field: 'purchased',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:true
                },
                {
                    label: 'In Service',
                    field: 'in_service',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                {
                    label: 'Warranty Applied',
                    field: 'status',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: 'Yes', // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
            ],
            rows: [],
            totalRecords: 0,
            // serverParams: {
            //     columnFilters: {},
            //     sort: {
            //         field: 'updated_at',
            //         type: 'desc',
            //     },
            //     page: 1,
            //     perPage: 50
            // },
            customer_value: false,
            loading:false,
            fromDate:"",
            readingError:"",
            unit:"",
            readingDate:"",
            showSelectAllLink:false,
            buttonVis:false,
            warCode:"",
            warrantyId:"",
            currentStatus:"Yes",
            starting_point_value:"",
            effective_date:"",
            expiry_date:"",
            canRemoveWarranty:false,
            canUpdateWarranty:false,
            canAddWarranty:false,
            userColumns:[],
            action:'list'
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_warranty') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_warranty') {
                            self.canAddWarranty = true;
                            self.canUpdateWarranty = true;
                        }

                        if (permissions[i].name == 'delete_warranty') {
                            self.canRemoveWarranty = true;
                        }
                    }
                }
            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.warrantyId = segments[3];
            self.getPermissions();
            // this.loadReport();
            self.getWarrantyInfo(segments[3]);
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.assetWarrantyList.unselectAllInternal();
            },

            getWarrantyInfo(id){
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/warranty/"+id,
                    type: "GET",
                    headers: this.ajxHeaders,
                    data:{flag:'from_asset'},
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);
                        var storeObject={visited_page: {
                                    path : "Warranties |" +data.content.code,
                                    data : window.location.pathname,
                                    }};
                            self.getRecentlyPagesMethod(storeObject);
                        self.warCode = data.content.code+' | '+data.content.description;
                        self.starting_point_value = data.content.starting_point_value;
                        self.effective_date = data.content.effective_date;
                        self.expiry_date = data.content.expiry_date;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },

            // updateParams(newProps) {
            //     this.serverParams = Object.assign({}, this.serverParams, newProps);
            // },

            // onPageChange(params) {
            //     this.updateParams({page: params.currentPage});
            //     this.loadReport();
            // },

            // onPerPageChange(params) {
            //     this.updateParams({perPage: params.currentPerPage});
            //     this.totalRecords = self.totalRecords;
            //     this.serverParams.page = 1 ;
            //     this.loadReport();
            // },

            // onColumnFilter(params) {
            //     this.updateParams(params);
            //     {
            //         field:('location');
            //         field:('unit_no');
            //         field:('pre_date');
            //     };
            //     var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
            //     var filters = filtersPr.columnFilters;
            //     this.serverParams.page = 1 ;
            //     if (this.firstLoad == 1 || filters.location || filters.unit_no || filters.pre_date ) {
            //         this.loadReport();
            //     }
            // },
            // onSelectAll(params) {

            //     if ( params.selectedRows.length > 0 ) {
            //         this.showSelectAllLink = true;
            //     } else {
            //         this.showSelectAllLink = false;
            //     }
            // },
            BackWarrantyList() {
                var self = this;
                if (self.$route.query.wo != undefined){
                    self.$router.push("/warranty/view/"+self.$route.query.wo);
                }else{
                    self.$router.push("/warranty/list");
                }
            },
            selectionChanged(param) {
                var self = this;
                var rowData = self.$refs['assetWarrantyList'].selectedRows;
                if(rowData.length > 0){
                    self.buttonVis = true;
                }else{
                    self.buttonVis = false;
                }
                console.log(rowData);
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },

            // onSortChange(params) {
            //     this.updateParams({
            //         sort: {
            //             type: params[0].type,
            //             field: params[0].field,
            //         },
            //     });
            //     this.loadReport();
            // },

            loadList() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (!self.serverParams.columnFilters.length) {
                    self.currentStatus = "No";
                }
                var use = [];
                var rowData = self.$refs['assetWarrantyList'].selectedRows;

                for (var i = 0; i < rowData.length; i++){
                    use.push(rowData[i].id);
                }

                if (self.serverParams.selectedAll && self.serverParams.selectedAll == true){
                    use = [];
                }

                self.loading = true;
                var fields = {
                    warranty_id:segments[3],
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    status:self.currentStatus,
                    selectedAll:self.serverParams.selectedAll,
                    selectedRows:use,
                    action:self.action
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/asset_warranty/list",
                    type: "GET",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);
                        if (data.code == 200) {
                            if (self.action == 'add_warranty'){
                                self.action = 'list';
                                self.$swal('','Warranty Added Successfully','success');
                            //  self.serverParams.columnFilters['status'] = 'Yes';
                                self.$refs.filterAssetWarranty.assetWarrantyFilter("Yes");
                                self.currentStatus = "Yes";
                                self.$refs.filterAssetWarranty.clearSelectAll();
                                // self.loadList();
                                EventBus.$emit('clear-all-flags', false);
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                if (data.content.row.length > 0) {
                                    if(data.content.row[0].status){
                                        self.currentStatus = data.content.row[0].status;
                                    }
                                }
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            addAssetWarranty() {

                var self = this;
                self.action = 'add_warranty';
                self.loadList();

            },
            removeAssetWarranty(){
                var self = this;

                var rowData = self.$refs['assetWarrantyList'].selectedRows;
                self.loading = true;

                $.ajax({
                url: process.env.ROOT_API + "/remove_warranty_vehicles",
                type: "POST",
                data: {arr:rowData,
                warranty_id:self.warrantyId},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;

                    if (data.code == 200) {
                       self.$swal('',data.message,'success');
                    //    self.serverParams.columnFilters['status'] = 'No';
                       self.$refs.filterAssetWarranty.assetWarrantyFilter("No");
                       self.currentStatus = "No";
                    }else if(data.code == 201){
                        self.$swal('',data.message,'info');
                    }
                },
                error: function (jqXHR, exception) {

                   self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                    }
                }
            });
            },
            formatString(data) {

                if (data == null){
                }else{
                    var self = this;
                    var value = data.replace(/_/g, " ");
                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;
                }
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/AssetWarrantyList.vue